export const APP_CONFIG = {
  APP_AUTHOR: 'Snalabz',
  APP_NAME: 'Classveew',
  APP_VERSION: '1.0.0',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:2375/v2',
  ACCESS_TOKEN_EXPIRY: Number(import.meta.env.VITE_ACCESS_TOKEN_EXPIRY) || 15, //minutes
  REFRESH_TOKEN_EXPIRY: Number(import.meta.env.VITE_REFRESH_TOKEN_EXPIRY) || 1440, // minutes
  SESSION_TIMEOUT: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 20,
  SESSION_TIMEOUT_PROMPT_COUNTDOWN:
    Number(import.meta.env.VITE_SESSION_TIMEOUT_PROMPT_COUNTDOWN) || 10,
  CHANGE_PASSWORD_TOKEN_EXPIRY: Number(import.meta.env.VITE_CHANGE_PASSWORD_TOKEN_EXPIRY) || 15,
  PRIVILEGES_EXPIRY: Number(import.meta.env.VITE_PRIVILEGES_EXPIRY) || 1440, // minutes (24 hours)
};
